import axios from "axios";
import { getRoleBasedEndpoint } from "./apiHelper";

const api = axios.create({
  baseURL: (() => {
    const hostname = window.location.hostname;
    if (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname.includes("stagingapp")
    ) {
      return process.env.VUE_APP_API_BASE_URL;
    } else if (hostname.includes("beautyverse.id")) {
      return process.env.VUE_APP_PRODUCTION_API_BASE_URL;
    } else {
      const fallbackUrl = process.env.VUE_APP_API_BASE_URL; // Fallback
      return fallbackUrl;
    }
  })(),
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Tambahkan method helper untuk role-based requests
api.getWithRole = (service, config = {}) => {
  const endpoint = getRoleBasedEndpoint(service);
  return api.get(endpoint, config);
};

api.postWithRole = (service, data, config = {}) => {
  const endpoint = getRoleBasedEndpoint(service);
  return api.post(endpoint, data, config);
};

api.putWithRole = (service, data, config = {}) => {
  const endpoint = getRoleBasedEndpoint(service);
  return api.put(endpoint, data, config);
};

api.deleteWithRole = (service, config = {}) => {
  const endpoint = getRoleBasedEndpoint(service);
  return api.delete(endpoint, config);
};

export default api;